import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import { CustomService } from "../../../services/api/custom/CustomService";
import { toast } from "react-toastify";
import { Button } from "antd";

function RegisterVendedorForm() {
  const { id } = useParams();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      cpf: "",
      nome: "",
      email: "",
      telefone: "",
    },
  });

  // Fetch existing vendedor for edit
  useEffect(() => {
    if (!isEdit) return;
    CustomService.getRequest(`/interno/vendedor/${id}`)
      .then((resp) => {
        setValue("cpf", resp.cpf || "");
        setValue("nome", resp.nome || "");
        setValue("email", resp.email || "");
        setValue("telefone", resp.telefone || "");
      })
      .catch((err) => {
        console.error("Erro ao carregar vendedor:", err);
        toast.error("Erro ao carregar dados do vendedor.");
      });
  }, [id, isEdit, setValue]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        cpf: data.cpf.replace(/\D/g, ""),
        nome: data.nome,
        email: data.email,
        telefone: data.telefone.replace(/\D/g, ""),
      };

      if (isEdit) {
        await CustomService.patchRequest(`/interno/vendedor/${id}`, payload);
        toast.success("Vendedor atualizado com sucesso!");
      } else {
        await CustomService.postRequest("/interno/vendedor", payload);
        toast.success("Vendedor cadastrado com sucesso!");
      }
      reset();
      navigate("/vendedores");
    } catch (error) {
      console.error("Erro ao ${isEdit ? 'atualizar' : 'cadastrar'} vendedor:", error);
      toast.error(`Erro ao ${isEdit ? "atualizar" : "cadastrar"} vendedor.`);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
      <div>
        <label className="block mb-1">CPF:</label>
        <Controller
          name="cpf"
          control={control}
          rules={{ required: "CPF é obrigatório" }}
          render={({ field }) => (
            <InputMask mask="999.999.999-99" {...field}>
              {(inputProps) => (
                <input
                  {...inputProps}
                  type="text"
                  className="border border-gray-300 p-2 w-full"
                />
              )}
            </InputMask>
          )}
        />
        {errors.cpf && (
          <p className="text-red-500 text-sm">{errors.cpf.message}</p>
        )}
      </div>

      <div>
        <label className="block mb-1">Nome:</label>
        <input
          type="text"
          className="border border-gray-300 p-2 w-full"
          {...register("nome", { required: "Nome é obrigatório" })}
        />
        {errors.nome && (
          <p className="text-red-500 text-sm">{errors.nome.message}</p>
        )}
      </div>

      <div>
        <label className="block mb-1">Email:</label>
        <input
          type="email"
          className="border border-gray-300 p-2 w-full"
          {...register("email", {
            required: "Email é obrigatório",
            pattern: { value: /\S+@\S+\.\S+/, message: "Email inválido" },
          })}
        />
        {errors.email && (
          <p className="text-red-500 text-sm">{errors.email.message}</p>
        )}
      </div>

      <div>
        <label className="block mb-1">Telefone:</label>
        <Controller
          name="telefone"
          control={control}
          rules={{ required: "Telefone é obrigatório" }}
          render={({ field }) => (
            <InputMask mask="(99) 99999-9999" {...field}>
              {(inputProps) => (
                <input
                  {...inputProps}
                  type="text"
                  className="border border-gray-300 p-2 w-full"
                />
              )}
            </InputMask>
          )}
        />
        {errors.telefone && (
          <p className="text-red-500 text-sm">{errors.telefone.message}</p>
        )}
      </div>

      <div className="flex justify-end gap-2">
        <Button onClick={() => navigate("/vendedores")}>Cancelar</Button>
        <Button type="primary" htmlType="submit">
          {isEdit ? "Salvar" : "Salvar"}
        </Button>
      </div>
    </form>
  );
}

export default RegisterVendedorForm;